import ReactCountryFlag from "react-country-flag";
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'pt', htmlLang: 'pt-BR', countryCode: 'BR', labelKey: 'language_pt' },
  { code: 'en', htmlLang: 'en-GB', countryCode: 'GB', labelKey: 'language_en' },
];

export const LanguageSwitcher = ({ className }) => {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage;

  return (
    <div className={className} role="group" aria-label={t('language_label')}>
      {LANGUAGES.map(({ code, htmlLang, countryCode, labelKey }) => {
        const selected = current === code;
        return (
          <button
            key={code}
            type="button"
            lang={htmlLang}
            className={`${code}${selected ? ' selected' : ''}`}
            aria-label={t(labelKey)}
            aria-pressed={selected}
            title={t(labelKey)}
            onClick={() => i18n.changeLanguage(code)}
          >
            <ReactCountryFlag countryCode={countryCode} svg aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
};